import { Injectable } from '@angular/core';
import { CanLoad } from '@angular/router';
import { UrlRedirectService } from '@ddt-web/url';
import { UserDataService } from '@ddt-web/user-data';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class PilotUserGuard implements CanLoad {
	constructor(
		private userDataService: UserDataService,
		private urlRedirectService: UrlRedirectService
	) { }

	public canLoad(): Observable<boolean> {
		return this.userDataService
			.isPilotUser$()
			.pipe(
				tap(isPilotUser => {
					if (!isPilotUser) {
						this.urlRedirectService.redirectToRoute('/');
					}
				}),
				catchError(() => {
					this.urlRedirectService.redirectToRoute('/');
					return of(false);
				})
			);
	}
}
